import Developer from '../views/Developer'
export default [
  {
    path: '/developer',
    name: 'developer',
    component: Developer
  }
]
